import * as React from 'react'
import PropTypes from 'prop-types'
import { tasteType } from '@/model/wine'

import Item from './Item'

import {
  Container
} from './style'

const Table = ({ items }) => {
  return (
    <Container>
      {
        items.map((item, i) => (
          <Item key={ i } item={ item } />
        ))
      }
    </Container>
  )
}

Table.propTypes = {
  items: PropTypes.arrayOf(tasteType)
}

export default Table
